class ProductOtherOffers extends HTMLElement {
  connectedCallback() {
    this.productForm = document.querySelector('[data-product-main-from]');

    if (!this.dataset.productHandle || !this.productForm) {
      return;
    }

    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  #init() {
    new Vue({
      el: this,
      data: {
        productForm: this.productForm,
        productHandle: this.dataset.productHandle,
        product: null,
        productOffers: [],
        refurbishedProducts: {},
        currentVariantId: null,
        discount: null,
      },
      template: `
        <div class="product__other-offers" v-if="productOffers.length">
          <h4 class="product__other-offers-heading">Other offers:</h4>  
          
          <div class="product__other-offers-list">
            <template  v-for="variant in productOffers">
              <div class="product__other-offers-item">
                <div class="info">
                  <div class="badge">{{ variant.isRefurbished ? 'Refurbished' : 'New' }}</div>
                  <div class="price" v-html="$options.filters.formatMoney(variant.price)"></div>
                  <div class="shipping">& FREE Shipping</div>
                  <template v-if="getArrives(variant)">
                    <div class="arrives" v-if="">Arrives: {{ getArrives(variant) }}</div>
                    <div class="ships-from">Ships from China</div>
                  </template>
                  <template v-else-if="getUsuallyShips(variant)">
                    <div class="usually-ships">{{ getUsuallyShips(variant) }}</div>
                  </template>
                  
                  <template v-if="variant.isRefurbished && variant.product_images && variant.product_images.length">
                    <a href="#" @click.prevent="openGallery(variant.product_images)" class="preview-photos">Review photos</a>
                  </template>
                </div>
  
                <button class="button button--atc button--icon" :disabled="!variant.available" @click.prevent="handleAddToCart(variant)" aria-label="Add to cart">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_310_316)">
                      <path d="M22.713 4.077C22.4317 3.73944 22.0796 3.46795 21.6815 3.28182C21.2835 3.09568 20.8494 2.99946 20.41 3H4.242L4.2 2.649C4.11405 1.91942 3.76339 1.24673 3.21449 0.758478C2.6656 0.270223 1.95663 0.000341793 1.222 0L1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H1.222C1.46693 2.00003 1.70334 2.08996 1.88637 2.25272C2.06941 2.41547 2.18634 2.63975 2.215 2.883L3.591 14.583C3.73385 15.7998 4.31848 16.9218 5.23391 17.736C6.14934 18.5502 7.33186 19 8.557 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17H8.557C7.93806 16.9983 7.3348 16.8051 6.82994 16.4471C6.32507 16.089 5.94331 15.5835 5.737 15H17.657C18.8293 15.0001 19.9643 14.5882 20.8638 13.8364C21.7633 13.0846 22.37 12.0407 22.578 10.887L23.363 6.533C23.4414 6.10101 23.4237 5.65707 23.3114 5.23264C23.1991 4.80821 22.9948 4.41368 22.713 4.077Z" fill="#FFA500"/>
                      <path d="M7 24C8.10457 24 9 23.1046 9 22C9 20.8954 8.10457 20 7 20C5.89543 20 5 20.8954 5 22C5 23.1046 5.89543 24 7 24Z" fill="#FFA500"/>
                      <path d="M17 24C18.1046 24 19 23.1046 19 22C19 20.8954 18.1046 20 17 20C15.8954 20 15 20.8954 15 22C15 23.1046 15.8954 24 17 24Z" fill="#FFA500"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_310_316">
                        <rect width="24" height="24" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            </template>
          </div>
        </div>
      `,

      async mounted() {
        this.setupEventListeners();

        this.discount = Shopify.discount.getCurrentDiscountCode();
        this.product = await Shopify.shopifyService.fetchProduct(this.productHandle);

        const gids = [];

        this.product?.variants.forEach(variant => {
          if (variant.refurbished_product) {
            gids.push(variant.refurbished_product);
          }
        });

        if (gids.length) {
          const response = await Shopify.shopifyService.fetchProducts(gids);
          response.data.nodes
            .filter(node => node)
            .forEach(refurbishedProduct => {
              const refurbishedVariant = refurbishedProduct.variants.edges[0].node;
              refurbishedVariant.id = refurbishedVariant.id.replace('gid://shopify/ProductVariant/', '');
              refurbishedVariant.price = refurbishedVariant.price.amount * 100;
              refurbishedVariant.available = refurbishedVariant.availableForSale;
              refurbishedVariant.name =
                refurbishedProduct.title + ' ' + refurbishedVariant.title.replace('Default Title', '');
              refurbishedVariant.arrives = refurbishedVariant.arrives ? refurbishedVariant.arrives.value : null;
              refurbishedVariant.restock = refurbishedVariant.restock ? refurbishedVariant.restock.value : null;
              refurbishedVariant.ships_from = refurbishedVariant.ships_from
                ? refurbishedVariant.ships_from.value
                : null;
              refurbishedVariant.product_images = [];
              refurbishedVariant.product = {
                id: Number(refurbishedProduct.id.replace('gid://shopify/Product/', '')),
                collections: refurbishedProduct.collections.edges.map(edge => ({
                  id: Number(edge.node.id.replace('gid://shopify/Collection/', '')),
                  handle: edge.node.handle,
                })),
              };

              if (refurbishedVariant.available) {
                const variant = this.product.variants.find(
                  variant => variant.refurbished_product && variant.refurbished_product === refurbishedProduct.id,
                );
                this.refurbishedProducts[variant.id] = refurbishedVariant;
              }
            });

          this.productOffers = this.getProductOffers();
        }
      },

      methods: {
        setupEventListeners() {
          document.addEventListener('product.variant.change', e => {
            this.currentVariantId = e.detail.variantId;
            this.productOffers = this.getProductOffers();
          });

          Shopify.discount.onUpdated(async event => {
            this.discount = event;
            this.productOffers = this.getProductOffers();
          });
        },

        getProductOffers() {
          if (!this.product) return [];

          const currentVariant = this.getCurrentVariant();

          const offers = [];
          const variantPlus = clone(this.getVariantPlus(currentVariant));
          const variantRefurbished = clone(this.getVariantRefurbished(currentVariant));
          const isComingSoon = this.isComingSoon(currentVariant);

          if (variantPlus && isComingSoon) {
            offers.push(variantPlus);
          }

          if (variantRefurbished) {
            variantRefurbished.isRefurbished = true;
            offers.push(variantRefurbished);
          }

          offers.forEach(variant => {
            const isProductEligibleForDiscount = Shopify.discount.isProductEligibleForDiscount(
              variant.product,
              this.discount,
            );

            variant.price = isProductEligibleForDiscount
              ? Shopify.discount.getPriceWithDiscount(variant.price, this.discount)
              : variant.price;
          });

          return offers;
        },

        getUsuallyShips(variant) {
          const variantRestock = variant.restock;
          let usuallyShips = variant.usually_ships_within;
          if (
            !usuallyShips &&
            (variant.title.includes('220V') ||
              variant.title.includes('110V (PLUS)') ||
              variant.title.includes('N/A (PLUS)'))
          ) {
            usuallyShips = '6-10';
          }

          if (usuallyShips && (!variantRestock || new Date(variantRestock).getTime() < new Date().getTime())) {
            return `Ships from China within ${usuallyShips.replace('-', ' to ')} days`;
          }
        },

        getArrives(variant) {
          const variantRestock = variant.restock;
          const usuallyShips = this.getUsuallyShips(variant);

          let variantArrives = variant.arrives;
          if (
            !variantArrives &&
            (variant.title.includes('110V') || variant.title.includes('N/A')) &&
            !variant.title.includes('PLUS') &&
            !usuallyShips
          ) {
            variantArrives = '3-6';
          }

          if (variantArrives) {
            const daysFrom = variantArrives.split('-')[0];
            const daysTo = variantArrives.split('-')[1];
            let secondsFrom = Date.now() + daysFrom * 24 * 60 * 60 * 1000;
            let secondsTo = Date.now() + daysTo * 24 * 60 * 60 * 1000;

            if (variantRestock && new Date(variantRestock).getTime() > Date.now()) {
              const daysDif = new Date(variantRestock).getTime() - Date.now();
              secondsFrom = secondsFrom + daysDif;
              secondsTo = secondsTo + daysDif;
            }

            return new Date(secondsFrom).getMonth() === new Date(secondsTo).getMonth()
              ? `${new Date(secondsFrom).mmdd()} - ${new Date(secondsTo).getDate()}`
              : `${new Date(secondsFrom).mmdd()} - ${new Date(secondsTo).mmdd()}`;
          }
        },

        getDetails(variant) {
          const element = document.querySelector('.product-plug li.active');
          const plugValue = element ? element.dataset.plugValue : null;

          if (plugValue) {
            return `SKU: ${variant.sku || variant.name} - Plug: ${plugValue}`;
          }
        },

        getCurrentVariant() {
          const currentVariantId = this.currentVariantId || this.getCurrentVariantId();
          return currentVariantId
            ? this.product.variants.find(variant => variant.id === Number(currentVariantId))
            : this.product.variants[0];
        },

        getVariantPlus(currentVariant) {
          if (currentVariant && !currentVariant.options.includes('PLUS')) {
            if (currentVariant.options.includes('110V')) {
              const variantsByVoltage110VPLUS = this.product.variants.filter(variant =>
                variant.options.includes('110V (PLUS)'),
              );
              return variantsByVoltage110VPLUS.find(variant =>
                variant.options.every(
                  option => option === '110V (PLUS)' || currentVariant.options.some(o => option === o),
                ),
              );
            }

            if (currentVariant.title.includes('N/A')) {
              const variantsByVoltageNAPLUS = this.product.variants.filter(variant =>
                variant.options.includes('N/A (PLUS)'),
              );
              return variantsByVoltageNAPLUS.find(variant =>
                variant.options.every(
                  option => option === 'N/A (PLUS)' || currentVariant.options.some(o => option === o),
                ),
              );
            }
          }
        },

        getVariantRefurbished(currentVariant) {
          return this.refurbishedProducts[currentVariant.id];
        },

        isComingSoon(variant) {
          const shipsFrom = this.getShipsFrom(variant);
          const isShipsFromChina = shipsFrom ? shipsFrom.toLowerCase().includes('china') : false;

          if (!isShipsFromChina && variant.inventory_management !== null && variant.inventory_quantity < 1) {
            return true;
          }
        },

        getDeadlineForDelivery(variant) {
          const variantRestock = variant.restock;
          const usuallyShips = this.getUsuallyShips(variant);

          let variantArrives = variant.arrives;
          if (
            !variantArrives &&
            (variant.title.includes('110V') || variant.title.includes('N/A')) &&
            !variant.title.includes('PLUS') &&
            !usuallyShips
          ) {
            variantArrives = '3-6';
          }

          if (variantArrives) {
            const daysTo = variantArrives.split('-')[1];
            let secondsTo = Date.now() + daysTo * 24 * 60 * 60 * 1000;

            if (
              variantRestock &&
              new Date(variantRestock).getTime() > Date.now() &&
              variant.inventory_management !== null &&
              variant.inventory_quantity < 1
            ) {
              const daysDif = new Date(variantRestock).getTime() - Date.now();
              secondsTo = secondsTo + daysDif;
            }

            return secondsTo;
          }
        },

        getShipsFrom(variant) {
          let shipsFrom = variant.ships_from;

          if (!shipsFrom) {
            if ((variant.title.includes('110V') || variant.title.includes('N/A')) && !variant.title.includes('PLUS')) {
              shipsFrom = 'United States';
            }
            if (
              variant.title.includes('110V (PLUS)') ||
              variant.title.includes('N/A (PLUS)') ||
              variant.title.includes('220V')
            ) {
              shipsFrom = 'China';
            }
          }

          return shipsFrom;
        },

        getCurrentVariantId() {
          const href = window.location.href;
          const index = href.search(/\?/) + 1;
          const newLocation = href.substr(0, index) + href.slice(index).replace(/\?/g, '&');
          history.pushState(null, null, newLocation);

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          return urlParams.get('variant');
        },

        openGallery(images) {
          if (!images) return;

          const gallery = images.map(image => ({
            src: image,
            thumb: image,
            typer: 'image',
          }));

          if (gallery.length) {
            Fancybox.show(gallery, {infinite: false});
          }
        },

        handleAddToCart(variant) {
          if (this.addedingToCart) return;
          this.addedingToCart = true;

          const formSerialize = serializeForm(this.productForm);
          const details = this.getDetails(variant);
          const arrives = this.getArrives(variant) || this.getUsuallyShips(variant);

          window.cartDrawer
            .add({
              items: [
                {
                  id: variant.id,
                  quantity: 1,
                  properties: {
                    DETAILS: details,
                    Arrives: arrives,
                  },
                },
              ],
            })
            .then(() => {
              Shopify.cart.setNote(formSerialize.note);
              this.addedingToCart = false;
            });
        },
      },

      filters: {
        formatMoney(price) {
          return formatMoney(price);
        },
      },
    });
  }
}

customElements.define('product-other-offers', ProductOtherOffers);
